import { createJsonHttpRequest, authTokenHandler, zipkinTraceHandler } from "@jutro/transport";
import { getConfigValue } from "@jutro/config";
var zipkinHandlerInstance = null;
export var createTSMRequest = function createTSMRequest(serverUrl) {
  return createJsonHttpRequest(serverUrl, !1).addHandler((zipkinHandlerInstance || (zipkinHandlerInstance = zipkinTraceHandler("TSM", "Jutro with TSM")), zipkinHandlerInstance)).addHandler(authTokenHandler);
};
export var isTSMEnabled = function isTSMEnabled() {
  return getConfigValue("JUTRO_AUTH_ENABLED", !1) && getConfigValue("JUTRO_TSM_ENABLED", !1);
};